import { Icon, IconProps } from "@chakra-ui/react"

const ReviewsIcon = (props: IconProps) => (
  <Icon
    xmlns='http://www.w3.org/2000/svg'
    width='15px'
    height='14px'
    viewBox='0 0 15 14'
    fill='none'
    {...props}
  >
    <path
      d='M5.43083 8.7499L7.5 7.51525L9.56917 8.7499L9.01917 6.43392L10.8492 4.88938L8.44417 4.67951L7.5 2.507L6.55583 4.67951L4.15083 4.88938L5.98083 6.43392L5.43083 8.7499ZM0 14V1.32482C0 0.947161 0.128611 0.632078 0.385833 0.379575C0.643056 0.127072 0.963055 0.000546544 1.34583 0H13.6542C14.0375 0 14.3575 0.126525 14.6142 0.379575C14.8708 0.632625 14.9994 0.947708 15 1.32482V10.1534C15 10.5305 14.8714 10.8456 14.6142 11.0987C14.3569 11.3517 14.0369 11.478 13.6542 11.4774H2.56417L0 14ZM2.20833 10.6576H13.6542C13.7819 10.6576 13.8994 10.6051 14.0067 10.5002C14.1139 10.3953 14.1672 10.2797 14.1667 10.1534V1.324C14.1667 1.1983 14.1133 1.0827 14.0067 0.977221C13.9 0.871738 13.7825 0.81927 13.6542 0.819816H1.34583C1.21806 0.819816 1.10056 0.872284 0.993333 0.977221C0.886111 1.08216 0.832778 1.19775 0.833333 1.324V12.0062L2.20833 10.6576Z'
      fill='black'
    />
  </Icon>
)

export default ReviewsIcon
